import { v4 as uuidv4 } from "uuid";

export const useAttachmentHandlers = (formData, handleChange, errors) => {
  const handleAttachmentChange = (id, field, value) => {
    const index = formData.attachments.findIndex((att) => att.id === id);
    if (index !== -1) {
      handleChange(`attachments[${index}].${field}`, value);
    }
  };

  const handleAddAttachment = () => {
    handleChange("attachments", [
      ...formData.attachments,
      {
        id: uuidv4(),
        attachmentName: "",
        attachmentComments: "",
        chooseFiles: [],
      },
    ]);
  };

  const handleRemoveAttachment = (id) => {
    const remainingAttachments = formData.attachments.filter(
      (att) => att.id !== id
    );
    if (remainingAttachments.length > 0) {
      handleChange("attachments", remainingAttachments);
    } else {
      handleChange("attachments", [
        {
          id: uuidv4(),
          attachmentName: "",
          attachmentComments: "",
          chooseFiles: [],
        },
      ]);
    }
  };

  const getAttachmentError = (index, field) => {
    const errorPath = `attachments.${index}.${field}`;
    return errors?.[errorPath] || errors?.attachments?.[index]?.[field] || "";
  };

  const renderAttachments = (AttachmentComponent) => {
    return formData.attachments.map((att, index) => (
      <AttachmentComponent
        key={att.id}
        attachment={att}
        index={index}
        onAttachmentChange={handleAttachmentChange}
        onAddAttachment={handleAddAttachment}
        onRemoveAttachment={handleRemoveAttachment}
        getError={getAttachmentError}
        isRemoveDisabled={formData.attachments.length === 1}
      />
    ));
  };

  return {
    handleAttachmentChange,
    handleAddAttachment,
    handleRemoveAttachment,
    getAttachmentError,
    renderAttachments,
  };
};
